import { render, staticRenderFns } from "./DialogAbout.vue?vue&type=template&id=1f4d443b&"
import script from "./DialogAbout.vue?vue&type=script&setup=true&lang=js&"
export * from "./DialogAbout.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports